<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}<span v-if="box.extra" class="extra_price"
                                                                                 v-bind:style="[(box.extra > 0 ? {visibility: 'visible'} : {visibility: 'hidden'})]"> + {{ box.extra }} €</span>
        </div>
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <!-- SEARCHBOX -->
        <div class="filterbox-wrapper">
            <div id="filterbox" class="select-btn-box">
                <button id="button_filter_1" @click.prevent="setFilter"
                        v-bind:class="[ 'select-btn', 'basic-bg', (section === '1') ? 'active' : '' ]">
                    <span>Standard</span></button>
                <button id="button_filter_3" @click.prevent="setFilter"
                        v-bind:class="[ 'select-btn', 'basic-bg', (section === '3') ? 'active' : '' ]">
                    <span>Big Ben</span>
                </button>
                <button id="button_filter_4" @click.prevent="setFilter"
                        v-bind:class="[ 'select-btn', 'basic-bg', (section === '4') ? 'active' : '' ]">
                    <span>Golden Gate</span></button>
                <button id="button_filter_5" @click.prevent="setFilter"
                        v-bind:class="[ 'select-btn', 'basic-bg', (section === '5') ? 'active' : '' ]"><span>Moai</span>
                </button>
                <button id="button_filter_6" @click.prevent="setFilter"
                        v-bind:class="[ 'select-btn', 'basic-bg', (section === '6') ? 'active' : '' ]">
                    <span>Red Fort</span></button>
                <button id="button_filter_7" @click.prevent="setFilter"
                        v-bind:class="[ 'select-btn', 'basic-bg', (section === '7') ? 'active' : '' ]">
                    <span>Windsor</span>
                </button>
                <button id="button_filter_8" @click.prevent="setFilter"
                        v-bind:class="[ 'select-btn', 'basic-bg', (section === '8') ? 'active' : '' ]">
                    <span>Magic</span>
                </button>
            </div>
            <div class="filter-reset-btn" @click="resetFilter">Filter zurücksetzen</div>
        </div>

        <!-- FILTERBOXES -->
        <div class="fabric-select-btn-box">
            <div v-bind:class="[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]"
                 v-on:touchstart="touchstartup" v-on:mouseenter="scrollup" v-on:mouseleave="mouseleave"
                 v-on:touchend="touchend">
                <div class="top-arrow-text"
                     v-bind:style="[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                    {{ translations['Scroll up for further fabrics'] }}
                </div>
            </div>
            <div :id="box.component" class="fabric-select-btns" @scroll="itemsScroll">

                <div v-for="item in items"
                     v-bind:class="[ 'fabric-select-btn', isactive === item.sku ? 'active' : '' ]">
                    <img v-bind:src="this.baseurl + 'media/' + item.thumb" v-bind:alt="item.name"
                         v-bind:title="item.name" v-bind:id="item.sku" @click="updatePersonal"
                         v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color" v-bind:data-price='item.price'/>
                    <div class="name" v-bind:id="item.sku" @click="updatePersonal" v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color" v-bind:data-price='item.price'>{{ item.name }}
                    </div>
                    <button v-bind:class="[ 'zoom-btn', 'btn-standalone', (isactive === item.sku || item.sku === this.personal[box.component]) ? 'active' : '' ]"
                            v-bind:data-refnr="item.sku"
                            v-bind:data-title="item.name" v-bind:data-infotext='item.infotext'
                            v-bind:data-price='item.price'
                            type="button" @click="zoomFabric">Details
                    </button>
                </div>
            </div>
        </div>
        <div v-bind:class="[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]"
             v-on:touchstart="touchstartdown" v-on:mouseenter="scrolldown" v-on:mouseleave="mouseleave"
             v-on:touchend="touchend">
            <div class="bottom-arrow-text"
                 v-bind:style="[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                {{ translations['Scroll down for further fabrics'] }}
            </div>
        </div>
    </div>
    <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals"></zoom>
</template>
<script>
import Zoom from '../partials/Zoom.vue'

var jQuery = require('jquery')

export default {
  name: 'Buttons',
  data: function () {
    return {
      section: this.section,
      globals: window.shirtdesigner,
      show: {
        type: Boolean,
        required: true,
        twoWay: true
      },
      translations: window.shirtdesigner.translations,
      selectedScrollHeight: (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0),
      selectedClientHeight: (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0),
      scrollPosition: 0,
      scrolling: false,
      touchstart: false
    }
  },
  props: [ 'fabrics', 'items', 'box', 'filtertext', 'zoom', 'show', 'baseurl', 'personal', 'isactive', 'section', 'buttonsection' ],
  components: {
    Zoom
  },
  methods: {
    updatePersonal: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      if (event.currentTarget.dataset.btncolor) {
        this.$dispatch('updatePersonalData', [ 'button-color', event.currentTarget.dataset.btncolor ])
      }
      if (event.currentTarget.dataset.price !== 'undefined' && event.currentTarget.dataset.price !== '') {
        this.box.extra = (Number(event.currentTarget.dataset.price)).toFixed(2)
      } else {
        this.box.extra = '0,00'
      }
      this.isactive = event.currentTarget.id
    },
    scrolldown: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component)
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop + scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    scrollup: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component)
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop - scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    mouseleave: function () {
      if (this.scrolling) {
        window.clearInterval(this.scrolling)
        this.scrolling = false
      }
    },
    touchstartup: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component)
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop - scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchstartdown: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component)
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop + scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchend: function () {
      this.mouseleave()
    },
    setFilter: function (event) {
      var number = event.currentTarget.id.split('_')
      this.section = number[2]
      jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonList', { type: 'shirt', section: this.section }, function (data) {
        this.items = data
      }.bind(this))
    },
    resetFilter: function (event) {
      this.section = null
      jQuery.getJSON(window.shirtdesigner['baseurl'] + '/designer/ajax/getButtonList', { type: 'shirt', section: this.section }, function (data) {
        this.items = data
      }.bind(this))
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/jack/buttons/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    },
    checkMeasures: function () {
      this.selectedScrollHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0)
      this.selectedClientHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0)
    },
    itemsScroll: function () {
      var ele = document.getElementById(this.box.component)
      this.scrollPosition = ele.scrollTop
      this.checkMeasures()
    }
  },
  watch: {
    items: function () {
      this.checkMeasures()
    },
    filtertext: function () {
      this.checkMeasures()
    },
    buttonsection: function () {
      this.section = this.buttonsection
    }
  },
  ready: function () {
    this.checkMeasures()
    this.$dispatch('runDesignJQuery')
  },
  created: function () {
    this.section = this.buttonsection
  }
}
</script>



// WEBPACK FOOTER //
// Buttons.vue?18243f59